import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import verify_success_icon from "../../../images/verify_success_icon.png";
import Header from "../../Includes/Header";
import Footer from "../../Includes/Footer";

function VerificationSuccess() {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <Container fluid className="min-vh-custom">
        <br /><br /><br /><br />
        <Row className="mt-5">
          <Col md={12} className="text-center">
            <img src={verify_success_icon} width={60} alt="verify success icon" />
            <h3 className="text-center mt-3">{t('register.thank_you_title')}</h3>
            <p className="text-secondary mt-3">{t('register.thank_you_desc')}</p>
          </Col>
        </Row>
      </Container>
      <Footer full={true} />
    </>
  );
}

export default VerificationSuccess;
